import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ToolbarSectionProps {
  label: string;
  children: React.ReactNode;
}

const ToolbarSection = ({ label, children }: ToolbarSectionProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 1, pt: 0.25 }}>
    <Typography variant="caption" color="text.secondary" sx={{ fontSize: 9, lineHeight: 1.2, letterSpacing: 0.5, textTransform: 'uppercase' }}>
      {label}
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25, flexGrow: 1 }}>
      {children}
    </Box>
  </Box>
);

export default ToolbarSection;
